import { defineComponent as _defineComponent } from 'vue'
import { Modal } from '@shared/ui'
import PayBlocked from './PayBlocked.vue'
import { usePayModel } from '../model'
import { usePreloaderModel } from '@shared/model/preloader'


export default /*#__PURE__*/_defineComponent({
  __name: 'PayLockModal',
  setup(__props) {

const payModel = usePayModel()
const preloaderModel = usePreloaderModel()

const closeModal = () => {
  payModel.status = false
  preloaderModel.status = false
}

return { __sfc: true,payModel, preloaderModel, closeModal, Modal, PayBlocked }
}

})